// @systeme: contrat
// Les rappels programmés pour un élément, et les notifications.
import { z } from 'zod';
import { SchemaCanalRappel, SchemaStatutRappel } from '../enumerations.js';
import { SchemaInstant } from './elements.js';
export const SchemaRappel = z.object({
    id: z.uuid(),
    elementId: z.uuid(),
    declencheLe: SchemaInstant,
    canal: SchemaCanalRappel,
    statut: SchemaStatutRappel,
    /** D'où vient ce rappel : « veille_18h », « j-15 », « 1h_avant »… */
    libelle: z.string(),
    envoyeLe: SchemaInstant.nullable(),
});
/** Ce que le navigateur donne quand l'utilisatrice accepte les notifications. */
export const SchemaAbonnementPush = z.object({
    endpoint: z.url().max(2000),
    cles: z.object({ p256dh: z.string().min(1).max(500), auth: z.string().min(1).max(500) }),
    agent: z.string().max(300).optional(),
});
export const SchemaPreferencesNotifications = z.object({
    /** Recevoir les rappels sur ce compte (le refus dans le navigateur prime, évidemment). */
    pushActif: z.boolean().default(true),
});
export const SchemaEtatNotifications = z.object({
    clePublique: z.string().nullable(),
    preferences: SchemaPreferencesNotifications,
    /** Combien d'appareils de ce compte sont abonnés. */
    appareils: z.number().int().min(0),
});
/** Le contenu d'une notification push, tel que le service worker le reçoit. */
export const SchemaChargeNotification = z.object({
    titre: z.string(),
    corps: z.string(),
    /** L'élément concerné quand la notification n'en porte qu'un ; sinon nul (récapitulatif). */
    elementId: z.uuid().nullable(),
    /** L'écran à ouvrir. */
    url: z.string(),
    etiquette: z.string(),
});
//# sourceMappingURL=rappels.js.map